import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const uploadImageMutation = gql`
  mutation uploadImage($input: UploadImageInput!) {
    uploadImage(input: $input)
  }
`;

const uploadImageOptions = {
  props: ({ mutate }) => ({
    uploadImage: input =>
      mutate({
        variables: {
          input,
        },
      }),
  }),
};

export default graphql(uploadImageMutation, uploadImageOptions);
